import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  margin-top: 24px;\n  display: flex;\n  flex-direction: column;\n  @media (max-width: 768px) {\n    > nav {\n      display: none;\n    }\n\n    margin: 0 -16px !important;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { ArrowRight, Sizes } from "@/components/icon/IconList";
import theme from "@/themes/uiLibraryTheme";
import { Button } from "@bookips/solvook-ui-library";
import { Breadcrumbs, Link, styled, Typography } from "@mui/material";
import React, { useCallback, useMemo } from "react";
export const CategoryBreadCrumbView = (param)=>{
    let { currentDepth , findCategoryChildren , breadcrumbList , isLastDepth , handleCategoryMenu  } = param;
    const { palette  } = theme;
    const items = useMemo(()=>{
        var _findCategoryChildren;
        return (_findCategoryChildren = findCategoryChildren(currentDepth)) === null || _findCategoryChildren === void 0 ? void 0 : _findCategoryChildren.items;
    }, [
        currentDepth,
        findCategoryChildren
    ]);
    const nextRow = useCallback((index)=>index % 3 === 0, []);
    const numEmptyCells = useMemo(()=>{
        if (!items) return 0;
        const remainder = items.length % 3;
        return (3 - remainder) % 3;
    }, [
        items
    ]);
    return /*#__PURE__*/ _jsxs(CategoryQuickMenuContainer, {
        children: [
            /*#__PURE__*/ _jsx(CustomBreadcrumb, {
                separator: /*#__PURE__*/ _jsx(Icon, {
                    icon: ArrowRight,
                    size: Sizes.smallHalf,
                    color: palette.text["disabled"]
                }),
                "aria-label": "breadcrumb",
                children: breadcrumbList
            }),
            !isLastDepth && items && /*#__PURE__*/ _jsx(ButtonTable, {
                children: /*#__PURE__*/ _jsxs("tbody", {
                    children: [
                        items.map((item, index)=>{
                            var _item_name;
                            return /*#__PURE__*/ _jsxs(React.Fragment, {
                                children: [
                                    nextRow(index) && /*#__PURE__*/ _jsx("tr", {}),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: /*#__PURE__*/ _jsx(CustomButton, {
                                            onClick: ()=>{
                                                var _item_id;
                                                handleCategoryMenu((_item_id = item.id) !== null && _item_id !== void 0 ? _item_id : item.categoryId);
                                            },
                                            children: (_item_name = item.name) !== null && _item_name !== void 0 ? _item_name : item.title
                                        })
                                    })
                                ]
                            }, "".concat(index, "-").concat(item.name || item.title));
                        }),
                        numEmptyCells > 0 && /*#__PURE__*/ _jsx(React.Fragment, {
                            children: Array.from({
                                length: numEmptyCells
                            }).map((_, index)=>/*#__PURE__*/ _jsx("td", {
                                    children: /*#__PURE__*/ _jsx(CustomButton, {
                                        className: "empty"
                                    })
                                }, "empty-".concat(index)))
                        })
                    ]
                })
            })
        ]
    });
};
export const BreadCrumbItem = (param)=>{
    let { depth , onClick , item , list  } = param;
    const { palette  } = theme;
    if (depth === 1) return /*#__PURE__*/ _jsx(Link, {
        underline: "hover",
        color: "inherit",
        onClick: onClick,
        children: /*#__PURE__*/ _jsx(Typography, {
            variant: "body2",
            color: palette.text["secondary"],
            children: list[0].name + " - " + list[1].name
        })
    }, item.id);
    return /*#__PURE__*/ _jsx(Link, {
        underline: "hover",
        color: "inherit",
        onClick: onClick,
        children: /*#__PURE__*/ _jsx(Typography, {
            variant: "body2",
            color: palette.text["secondary"],
            children: item.name
        })
    }, item.id);
};
export const CustomBreadcrumb = styled(Breadcrumbs)((param)=>{
    let { theme  } = param;
    return {
        ".MuiLink-underlineHover": {
            "&:hover": {
                textUnderlineOffset: "3px",
                p: {
                    color: theme.palette.text["title"]
                }
            }
        },
        ol: {
            display: "flex",
            flexDirection: "row",
            padding: 0,
            margin: 0,
            alignItems: "center"
        }
    };
});
export const CategoryQuickMenuContainer = styled("div")(_templateObject());
export const ButtonGrid = styled("div")((param)=>{
    let { theme  } = param;
    return {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        marginTop: "12px",
        borderRadius: "6px",
        borderTop: "1px solid ".concat(theme.palette.grey[100]),
        marginRight: "-1px",
        [theme.breakpoints.down(1080)]: {
            gridTemplateColumns: "repeat(3, 1fr)"
        },
        [theme.breakpoints.down("sm")]: {
            borderRadius: "0",
            marginTop: "0",
            borderTop: "none"
        }
    };
});
export const CustomButton = styled(Button)((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        padding: "12px 16px",
        color: theme.palette.text["secondary"],
        borderRadius: 0,
        ...theme.typography.body2,
        "&:hover:not(&.empty)": {
            backgroundColor: "rgba(169, 175, 199, 0.20)",
            color: theme.palette.text["title"]
        },
        "&.empty": {
            pointerEvents: "none"
        }
    };
});
export const ButtonTable = styled("table")((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        marginTop: "12px",
        borderCollapse: "collapse",
        borderRadius: "6px",
        border: "1px solid ".concat(theme.palette.grey[100]),
        "& td": {
            border: "1px solid ".concat(theme.palette.grey[100]),
            padding: 0,
            width: "33.33%",
            textAlign: "center"
        }
    };
});
